/* eslint-disable */
import { makeAutoObservable } from 'mobx';

class agencyListDialogStore {
  constructor() {
    makeAutoObservable(this);
  }
  show = false;
  id = '';
  item = {};
  openAgencyDialog(item) {
    this.show = true;
    this.id = item?.id;
    this.item = item;
  }
  closeAgencyDialog() {
    this.show = false;
    this.id = '';
    this.item = {};
  }
}

export default new agencyListDialogStore();
